import React, { useCallback, useEffect, useState } from "react";
import { Modal, Typography, InputNumber } from "antd";
import { useTranslation } from "react-i18next";
import axios, { AxiosError, AxiosResponse } from "axios";
import api from "../../../services/api";
import { useToast } from "../../../hooks/toast";
import { IRequirement } from "../../Project";

const { Text } = Typography;

interface IEditActivityHoursModalProps {
  activity?: IRequirement;
  visible: boolean;
  handleClose: (activity?: IRequirement) => void;
}

const EditActivityHoursModal: React.FC<IEditActivityHoursModalProps> = ({
  activity,
  visible,
  handleClose,
}) => {
  const { t } = useTranslation(["activities-actions"]);
  const [loading, setLoading] = useState<boolean>(false);
  const [hours, setHours] = useState<number | undefined>(undefined);

  const { addToast } = useToast();

  const generateErrorToast = useCallback(
    (response: AxiosResponse | undefined) => {
      let description;

      switch (response?.status) {
        case 406:
          description = "A atividade precisa estar no estado Atribuida ou Em desenvolvimento para apontar horas";
          break;
        case 405:
          description = "O projeto não foi encontrado";
          break;
        case 404:
          description = "A atividade não foi encontrada";
          break;
        case 403:
          description =
            "As horas da atividade só podem ser apontadas pelo usuário atribuído";
          break;
        default:
          description =
            "Um erro occoreu ao apontar as horas da atividade, tente novamente";
      }

      addToast({
        type: "error",
        title: "Erro ao apontar as horas",
        description,
      });
    },
    [addToast],
  );

  const handleSubmit = useCallback(async () => {
    setLoading(true);

    try {
      const response = await api.patch(`/activities/${activity?.id}/edit-worked-hours`, {
        hours,
      });

      handleClose(response.data);

      addToast({
        type: "success",
        title: "Horas apontadas",
        description: "A atividade foi alterada com sucesso",
      });
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const serverError = err as AxiosError;
        generateErrorToast(serverError.response);
      } else {
        console.log(err);
      }
    }

    setLoading(false);
  }, [activity?.id, addToast, hours, generateErrorToast, handleClose]);

  return (
    <Modal
      title={t("edit-hours")}
      visible={visible}
      onOk={handleSubmit}
      onCancel={() => handleClose()}
      destroyOnClose
      okButtonProps={{
        loading,
        disabled: !hours,
      }}
      getContainer={false}
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Text style={{ marginBottom: 10 }}>
        {`Qual o tempo gasto na atividade "${activity?.description}" até então?`}
      </Text>
      <InputNumber
        style={{ width: 200 }}
        onChange={setHours}
        defaultValue={activity?.wasted_hours}
        min={1}
        max={400}
        addonAfter="horas"
      />
    </Modal>
  );
};

export default EditActivityHoursModal;
